import React from 'react';
import { motion } from 'framer-motion';
import { Leaf, Droplet, Shield, Zap } from 'lucide-react';
export function IngredientsSection() {
  const ingredients = [{
    name: 'Cleavers Aerial Parts',
    benefit: 'Reduces Stubborn Swelling',
    desc: 'A traditional lymph-moving herb that helps break up and move trapped fluid through your lymphatic channels, easing heavy legs, ankle puffiness, and overall fluid retention.',
    icon: <Leaf className="w-6 h-6" data-id="element-135" />,
    image: 'https://images.unsplash.com/photo-1620916297397-a4a5402a3c6c?auto=format&fit=crop&q=80&w=400'
  }, {
    name: 'Red Clover Blossom',
    benefit: 'Reduces Facial Puffiness',
    desc: 'Improves surface micro-circulation to smooth facial swelling, brighten skin tone, and support a more defined, lifted appearance — especially around the cheeks and jawline.',
    icon: <Droplet className="w-6 h-6" data-id="element-136" />,
    image: 'https://images.unsplash.com/photo-1540420773420-3366772f4999?auto=format&fit=crop&q=80&w=400'
  }, {
    name: 'Stillingia Root',
    benefit: 'Opens Lymph Pathways',
    desc: 'Known for its deep-cleansing properties, Stillingia helps clear congested lymph pathways so your body can naturally drain excess fluid and waste more efficiently.',
    icon: <Shield className="w-6 h-6" data-id="element-137" />,
    image: 'https://images.unsplash.com/photo-1615485290382-441e4d049cb5?auto=format&fit=crop&q=80&w=400'
  }, {
    name: 'Prickly Ash Bark',
    benefit: 'Energizes Slow Lymph Flow',
    desc: 'Stimulates circulation and gently activates slow or stagnant flow, helping relieve brain fog, fatigue, and that "sluggish, weighed-down" feeling.',
    icon: <Zap className="w-6 h-6" data-id="element-138" />,
    image: 'https://images.unsplash.com/photo-1518531933037-91b2f5f229cc?auto=format&fit=crop&q=80&w=400'
  }];
  return <section className="py-24 bg-[#F9FAFB]" data-id="element-139">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-140">
        <div className="text-center mb-16" data-id="element-141">
          <span className="text-[#10B981] font-bold uppercase tracking-wider text-sm" data-id="element-142">
            INGREDIENTS SECTION
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-[#1B5E20] mt-4 mb-6" data-id="element-143">
            Nature's Most Trusted Fluid-Balancing Herbs
          </h2>
          <p className="text-xl text-[#374151]" data-id="element-144">
            Each ingredient is chosen for its proven ability to support healthy
            drainage.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-145">
          {ingredients.map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-white p-6 rounded-3xl shadow-sm hover:shadow-md transition-shadow border border-gray-100 flex flex-col sm:flex-row gap-6 items-start" data-id="element-146">
              <div className="w-full sm:w-32 h-32 rounded-2xl overflow-hidden flex-shrink-0 relative" data-id="element-147">
                <img src={item.image} alt={item.name} className="w-full h-full object-cover" data-id="element-148" />
                <div className="absolute inset-0 bg-[#10B981]/10" data-id="element-149" />
              </div>

              <div data-id="element-150">
                <div className="flex items-center gap-2 mb-2" data-id="element-151">
                  <div className="p-1.5 bg-[#10B981]/10 rounded-lg text-[#10B981]" data-id="element-152">
                    {item.icon}
                  </div>
                  <h3 className="text-xl font-bold text-[#1B5E20]" data-id="element-153">
                    {item.name}
                  </h3>
                </div>
                <p className="text-[#10B981] font-bold text-xs uppercase tracking-wide mb-3" data-id="element-154">
                  {item.benefit}
                </p>
                <p className="text-[#374151] text-sm leading-relaxed" data-id="element-155">
                  {item.desc}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}